export enum UserRevalidationKey {
    Basket = '/baskets/summary',
    Delivery = '/delivery',
    FavoriteStore = '/stores/favorite',
    NewsletterSlot = '/content/slots/newsletter-content-global',
    NotifyMe = '/notify-me',
    ProductDeliveryInfo = '/product-delivery-info',
    ProductRecommendations = '/product-recommendations',
    Products = '/products',
    Promotion = '/promotion-infos',
    UnusedKey = '/unused', // DO NOT USE THIS KEY FOR REVALIDATION
    User = '/user',
    Wishlist = '/wishlists/summary',

    ContentAsset = '/content-asset',
    NotifyMeAsset = '/content-asset/notify-me',
    PriceRegulationAsset = '/content-asset/price-regulation',
    LegalMentionsAsset = '/content-asset/legal-mentions',
    EngravingForm = '/form/engraving',
    RatingReviewForm = '/form/rating-review',
}
